import { lazy, Suspense } from 'react';
import theme from './theme';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { Navigate, Route, Routes } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import DashboardLayout from './layouts/DashboardLayout';
const AnalyticsPage = lazy(() => import('./pages/AnalyticsPage'));
const AuditLogsPage = lazy(() => import('./pages/AuditLogsPage'));

const GeographicPage = lazy(() => import('./pages/GeographicPage'));
const LoginPage = lazy(() => import('./pages/LoginPage'));
const ModerationStatsPage = lazy(() => import('./pages/ModerationStatsPage'));
const NotificationsPage = lazy(() => import('./pages/NotificationsPage'));
const PremiumRewardsPage = lazy(() => import('./pages/PremiumRewardsPage'));
const PromotionsPage = lazy(() => import('./pages/PromotionsPage'));
const PushCampaignsPage = lazy(() => import('./pages/PushCampaignsPage'));
const ReportsPage = lazy(() => import('./pages/ReportsPage'));
const SubscriptionsPage = lazy(() => import('./pages/SubscriptionsPage'));
const TicketsPage = lazy(() => import('./pages/TicketsPage'));
const UserSegmentsPage = lazy(() => import('./pages/UserSegmentsPage'));
const UsersPage = lazy(() => import('./pages/UsersPage'));
const VerificationsPage = lazy(() => import('./pages/VerificationsPage'));
const VerificationStatsPage = lazy(
  () => import('./pages/VerificationStatsPage')
);
const ViolationDetailsPage = lazy(() => import('./pages/ViolationDetailsPage'));
const ViolationsPage = lazy(() => import('./pages/ViolationsPage'));
const WaitlistPage = lazy(() => import('./pages/WaitlistPage'));

const VerificationAiPage = lazy(() => import('./pages/VerificationAiPage'));

const OperationalHome = lazy(() => import('./pages/OperationalHome'));

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Suspense fallback={<div role="status">Chargement de l’espace…</div>}>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<OperationalHome />} />
            <Route
              path="decision-hub"
              element={<Navigate to="/dashboard" replace />}
            />
            <Route path="segments" element={<UserSegmentsPage />} />
            <Route path="reports" element={<ReportsPage />} />
            <Route path="verifications" element={<VerificationsPage />} />
            <Route path="verification-ai" element={<VerificationAiPage />} />
            <Route
              path="verification-stats"
              element={<VerificationStatsPage />}
            />
            <Route path="moderation/stats" element={<ModerationStatsPage />} />
            <Route path="moderation/violations" element={<ViolationsPage />} />
            <Route
              path="moderation/violations/:violationId"
              element={<ViolationDetailsPage />}
            />
            <Route path="tickets" element={<TicketsPage />} />
            <Route path="users" element={<UsersPage />} />
            <Route path="subscriptions" element={<SubscriptionsPage />} />
            <Route path="premium-rewards" element={<PremiumRewardsPage />} />
            <Route path="promotions" element={<PromotionsPage />} />
            <Route path="analytics" element={<AnalyticsPage />} />
            <Route path="geographic" element={<GeographicPage />} />
            <Route path="notifications" element={<NotificationsPage />} />
            <Route path="push-campaigns" element={<PushCampaignsPage />} />
            <Route path="waitlist" element={<WaitlistPage />} />
            <Route path="audit-logs" element={<AuditLogsPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </Suspense>
    </ThemeProvider>
  );
}

export default App;
